import React, { useState, useCallback, FC, useEffect } from 'react';
import Accordion from 'b2b-ui-components-lib/lib/components/accordion';
import Button from 'b2b-ui-components-lib/lib/components/button';
import './index.scss';
import { FormBuilder, IFORM } from 'featureLib/FormBuilder';
import { isFormValid } from 'featureLib/FormBuilder/form.validator';
import { getVisibleFormFields, isSingleUpgradeOrShiftingJourney } from 'common/utils/app.utils';
import { isAOIOrder } from 'common/constants/app.constants';

type Props = {
  onSubmit: Function;
  orderFormSchema: { [key: string]: any };
  contactFormSchema: { [key: string]: any };
  onSubmitOrder: Function;
  onSubmitContact: Function;
  onOrderFieldChange: Function;
  onContactFieldChange: Function;
  loader?: boolean;
  disableBtn?: boolean;
  onEdit?: Function;
  submitBtnName?: string;
  showEditBtn?: boolean;
};

export const OrderDetails: FC<Props> = ({
  onSubmit,
  orderFormSchema,
  contactFormSchema,
  onSubmitOrder,
  onSubmitContact,
  onOrderFieldChange,
  onContactFieldChange,
  loader,
  disableBtn,
  onEdit,
  submitBtnName = 'Next',
  showEditBtn = false
}: Props) => {
  const getHeading = () => {
    return (
      <div className="get_heading">
        <h2 className="title-head">
          {isAOIOrder() ? 'FSE Details' : ' Order Details'}
          <span>All fields are mandatory unless marked optional.</span>
        </h2>
      </div>
    );
  };

  const isProceedDisabled = () => {
    const filteredFields = getVisibleFormFields({ ...orderFormSchema, ...contactFormSchema });
    const isFormNotValid = !isFormValid(filteredFields);

    return isFormNotValid || disableBtn;
  };

  const showEditButton = () => {
    const visibleFields = getVisibleFormFields({ ...orderFormSchema, ...contactFormSchema });
    const ifFormValid = isFormValid(visibleFields);
    const totalFieldsCount = Object.keys(visibleFields).length;
    let disabledFieldsCount = 0;

    if (ifFormValid) {
      Object.entries(visibleFields).forEach(([_key, value]) => {
        if ((value as any)?.disabled) {
          disabledFieldsCount++;
        }
      });
    }

    if (disabledFieldsCount === totalFieldsCount) {
      return true;
    } else {
      return false;
    }
  };

  if (isAOIOrder()) {
    return (
      <div className="order_form">
        <Accordion title={getHeading()} isExpanded={true} autoScrollOnExpand={false} variant="round">
          <div className="form_section">
            <div className="row">
              <FormBuilder formConfig={orderFormSchema} onSubmit={onSubmitOrder} onChange={onOrderFieldChange}></FormBuilder>
            </div>
            {/* <div className="btn_action">
            {(isSingleUpgradeOrShiftingJourney() && showEditButton()) || showEditBtn ? (
              <Button onClick={onEdit} variant="outlinebtn" buttonClass="btnClass">
                Edit
              </Button>
            ) : (
              <Button onClick={onSubmit} buttonClass="btnClass" disabled={isProceedDisabled()}>
                {submitBtnName}
                {loader && <span className="loading_icon"></span>}
              </Button>
            )}
          </div> */}
          </div>
        </Accordion>
        <br />
        <Accordion
          title={
            <div className="get_heading">
              <h2 className="title-head">
                {isAOIOrder() ? 'KDM Details' : ' Order Details'}
                <span>All fields are mandatory unless marked optional.</span>
              </h2>
            </div>
          }
          isExpanded={true}
          autoScrollOnExpand={false}
          variant="round"
        >
          <div className="form_section">
            <div className="contact_section">
              {/* <h2 className="contact_head">{isAOIOrder() ? 'KDM Details' : 'Contact Details'}</h2> */}
              <div className="row">
                <FormBuilder formConfig={contactFormSchema} onSubmit={onSubmitContact} onChange={onContactFieldChange}></FormBuilder>
              </div>
            </div>
            <div className="btn_action">
              {(isSingleUpgradeOrShiftingJourney() && showEditButton()) || showEditBtn ? (
                <Button onClick={onEdit} variant="outlinebtn" buttonClass="btnClass">
                  Edit
                </Button>
              ) : (
                <Button onClick={onSubmit} buttonClass="btnClass" disabled={isProceedDisabled()}>
                  {submitBtnName}
                  {loader && <span className="loading_icon"></span>}
                </Button>
              )}
            </div>
          </div>
        </Accordion>
      </div>
    );
  }

  return (
    <div className="order_form">
      <Accordion title={getHeading()} isExpanded={true} autoScrollOnExpand={false} variant="round">
        <div className="form_section">
          <div className="row">
            <FormBuilder formConfig={orderFormSchema} onSubmit={onSubmitOrder} onChange={onOrderFieldChange}></FormBuilder>
          </div>
          <div className="contact_section">
            <h2 className="contact_head">{isAOIOrder() ? 'KDM Details' : 'Contact Details'}</h2>
            <div className="row">
              <FormBuilder formConfig={contactFormSchema} onSubmit={onSubmitContact} onChange={onContactFieldChange}></FormBuilder>
            </div>
          </div>
          <div className="btn_action">
            {(isSingleUpgradeOrShiftingJourney() && showEditButton()) || showEditBtn ? (
              <Button onClick={onEdit} variant="outlinebtn" buttonClass="btnClass">
                Edit
              </Button>
            ) : (
              <Button onClick={onSubmit} buttonClass="btnClass" disabled={isProceedDisabled()}>
                {submitBtnName}
                {loader && <span className="loading_icon"></span>}
              </Button>
            )}
          </div>
        </div>
      </Accordion>
    </div>
  );
};
export default OrderDetails;
